'use client';
import { jsx } from 'react/jsx-runtime';
import '@digdir/designsystemet-web';
import { forwardRef, useContext } from 'react';
import { Context } from './tabs.js';

/**
 * A single content item in a Tabs component.
 *
 * @example
 * <TabsPanel value='1'>content 1</TabsPanel>
 */
const TabsPanel = forwardRef(function TabsPanel({ children, value, id, className, ...rest }, ref) {
    const { getPrefixedValue } = useContext(Context);
    return (jsx("ds-tabpanel", { suppressHydrationWarning // Since <ds-tablist> adds attributes
        : true, ref: ref, id: id ?? getPrefixedValue?.(value), class: className, ...rest, children: children }));
});

export { TabsPanel };
